/* ════════════════════════════════════════════════════════════
   بيانات مولّد جدول المراجعة — من أداتك

   ⚠️ **المواد والنصائح منقولة حرفياً** من الملفّ الذي أرسلته. لم
   أخترع مادّة ولا نصيحة، ولم أُغيّر معاملاً.

   `COMMON` مواد مشتركة بين كل الشعب، و`ACTIONS` أنشطة لا مواد
   (مراجعة عامّة · راحة · تمارين) — والتمييز بينهما مقصود: الأولى
   تُوزَّع بالمعامل، والثانية تملأ الفراغ بلا حساب.
════════════════════════════════════════════════════════════ */

export interface PlanBranch {
  name: string;
  color: string;
  /** مواد التخصّص — الأثقل معاملاً */
  subjects: string[];
  /** نصيحة الشعبة كما كتبتها في أداتك */
  tip: string;
}

export const PLAN_BRANCHES: PlanBranch[] = [
  {
    "name": "علوم تجريبية",
    "color": "#1E8A5F",
    "subjects": [
      "علوم طبيعية",
      "فيزياء",
      "رياضيات"
    ],
    "tip": "المعاملات الكبرى هي العلوم (6)، الفيزياء (5)، والرياضيات (5). خصص 60-70% من جدولك لهذه المواد. لا تهمل مواد الحفظ (تاريخ، إسلامية) فهي ترفع المعدل العام بامتياز."
  },
  {
    "name": "رياضيات",
    "color": "#2350D9",
    "subjects": [
      "رياضيات",
      "فيزياء",
      "علوم طبيعية"
    ],
    "tip": "أنت في شعبة الرياضيات! معامل الرياضيات (7) والفيزياء (6). ركز بشدة على حل الأفكار الصعبة فيهما. أما العلوم الطبيعية (معامل 2) فهي مادة ثانوية بالنسبة لك، فلا تبالغ في إعطائها وقت المواد الأساسية."
  },
  {
    "name": "تقني رياضي",
    "color": "#D08217",
    "subjects": [
      "مادة التخصص",
      "رياضيات",
      "فيزياء"
    ],
    "tip": "مادة تخصصك (الهندسة) معاملها (7)، والرياضيات (6)، والفيزياء (5). خصص لها أوقات الذروة (الصباح الباكر). اللغات ومواد الحفظ خفيفة لكنها ضرورية لمن يبحث عن معدل يفوق 14."
  },
  {
    "name": "تسيير واقتصاد",
    "color": "#7C3AED",
    "subjects": [
      "محاسبة",
      "اقتصاد ومناجمنت",
      "رياضيات",
      "قانون"
    ],
    "tip": "المحاسبة (6)، الاقتصاد والمناجمنت (5)، والرياضيات (5) تتطلب ممارسة يومية بالورقة والقلم. القانون مادة ثانوية (معامل 2). اربط الحفظ بالفهم لتسهيل الاسترجاع."
  },
  {
    "name": "آداب وفلسفة",
    "color": "#C2410C",
    "subjects": [
      "فلسفة",
      "أدب عربي",
      "تاريخ وجغرافيا"
    ],
    "tip": "أدب عربي (6) وفلسفة (6) هما مفتاحا نجاحك. تدرب على منهجية المقال الفلسفي والتحليل الأدبي بانتظام. التاريخ والجغرافيا (4) تلعب دوراً حاسماً، فلا تهملها."
  },
  {
    "name": "لغات أجنبية",
    "color": "#0E7490",
    "subjects": [
      "أدب عربي",
      "لغة فرنسية",
      "لغة إنجليزية",
      "لغة إسبانية/ألمانية"
    ],
    "tip": "اللغات هي ملعبك: العربية (5)، الفرنسية (5)، الإنجليزية (5) واللغة الأجنبية الثالثة (4). الممارسة اليومية بكتابة الوضعيات الإدماجية وحل نصوص البكالوريات السابقة هو الأهم."
  }
];

/** مواد مشتركة بين كل الشعب */
export const COMMON_SUBJECTS: string[] = ["تاريخ وجغرافيا", "تربية إسلامية", "أدب عربي", "لغة فرنسية", "لغة إنجليزية", "فلسفة", "رياضيات"];

/** أنشطة لا مواد */
export const PLAN_ACTIONS: string[] = ["استراحة", "حل مواضيع / حوليات", "مراجعة خفيفة / حفظ"];

export const WEEK_DAYS = [
  "السبت", "الأحد", "الإثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة",
] as const;

export function getBranch(name: string): PlanBranch | null {
  return PLAN_BRANCHES.find((b) => b.name === name) ?? null;
}

/** كل ما يمكن وضعه في خانة: مواد الشعبة ثمّ المشتركة ثمّ الأنشطة */
export function cellOptions(branch: string): string[] {
  const b = getBranch(branch);
  return [...(b?.subjects ?? []), ...COMMON_SUBJECTS, ...PLAN_ACTIONS];
}
